import { S as Swiper, N as Navigation } from './navigation-_PFp8ZJV.js';

class FeaturesSlider extends HTMLElement {
  connectedCallback() {
    this.slides = Math.min(parseInt(this.dataset.slides) || 4, 4);

    this.initSwiper();
  }

  initSwiper() {
    new Swiper(this.querySelector('.swiper--features'), {
      modules: [Navigation],
      slidesPerView: 1.5,
      centeredSlides: false,
      watchOverflow: true,
      loop: true,
      breakpoints: {
        768: {
          slidesPerView: 3,
        },
        1024: {
          slidesPerView: this.slides,
        },
      },
      navigation: {
        nextEl: this.querySelector('.swiper-button-next--features'),
        prevEl: this.querySelector('.swiper-button-prev--features'),
      },
    });
  }
}
customElements.define('features-slider', FeaturesSlider);
